module.exports = __webpack_public_path__ + "img/20210422090640434vw5.dc422d2f.png";